import { useSelector } from 'react-redux';
import { STATE_MAPPER } from '../docs/constants';
import { selectRefiDocsFormData } from '../../redux-state/selectors';
import VehicleInfoRefiDoc from './VehicleInfoRefiDoc';
import TransactionInfoRefiDoc from './TransactionInfoRefiDoc';
import { formatDate } from '../utility/formatDate';

function RefiDocOutputLeft() {
  const refiDocsFormData = useSelector(selectRefiDocsFormData)

  const getStateFullName = (abbr) => {
    return STATE_MAPPER[abbr] || abbr;
  };

  return (
    <div className='flex flex-col gap-4 w-[100%]'>
      <div className='flex flex-row text-gray-700 font-bold mb-2 items-center h-11'>
        Your Information
      </div>

      <div className='bg-white p-6 rounded-xl text-sm border border-gray-300'>
        <div className='text-gray-700 mb-3 font-medium'>
          Location Information
        </div>

        <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6'>
          <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Zip Code:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.zipCode}
              </div>
            </div>

            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                City:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.city}
              </div>
            </div>

          </div>

          <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                State:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {getStateFullName(refiDocsFormData?.state)}
              </div>
            </div>

            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                County:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.country}
              </div>
            </div>
          </div>
        </div>

        <VehicleInfoRefiDoc/>
        <TransactionInfoRefiDoc/>

        {(refiDocsFormData?.insuranceCompany || refiDocsFormData?.insuranceExpirationDate || refiDocsFormData?.insuranceDate || refiDocsFormData?.insurancePolicyNumber) &&
          <div>
            <div className='border-t-2 border-t-gray-100 mb-3'>
              <div className='text-gray-700 mt-6 font-medium'>
                Insurance Information
              </div>
            </div>

            <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6'>
              <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
                <div className='flex flex-row justify-between gap-2 items-start'>
                  <div>
                    Insurance Company:
                  </div>
                  <div className='font-medium text-right break-words min-w-0'>
                    {refiDocsFormData?.insuranceCompany}
                  </div>
                </div>

                <div className='flex flex-row justify-between gap-2 items-start'>
                  <div>
                    Expiry Date:
                  </div>
                  <div className='font-medium text-right break-words min-w-0'>
                    {formatDate(refiDocsFormData?.insuranceExpirationDate)}
                  </div>
                </div>
              </div>

              <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
                <div className='flex flex-row justify-between gap-2 items-start'>
                  <div>
                    Insurance Date:
                  </div>
                  <div className='font-medium text-right break-words min-w-0'>
                    {formatDate(refiDocsFormData?.insuranceDate)}
                  </div>
                </div>

                <div className='flex flex-row justify-between gap-2 items-start'>
                  <div>
                    Insurance Number:
                  </div>
                  <div className='font-medium text-right break-words min-w-0'>
                    {refiDocsFormData?.insurancePolicyNumber}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default RefiDocOutputLeft